export default class ProductStackModal {
    constructor(productStack) {
        this.productStack = productStack
        this.modalCloseButtons = this.productStack.querySelectorAll('.js-product-stack__close')
        this.tileCollections = [...productStack.querySelectorAll('.js-product-stack__collection')]
        this.closeButtonListener()
    }

    closeButtonListener() {
        this.modalCloseButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.disableCollectionModal()
            })
        })

        document.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                this.disableCollectionModal()
            }
        })
    }

    activateCollectionModal(index) {
        this.disableCollectionModal()
        this.tileCollections[index].classList.add('product-stack__collection--active-modal')
    }

    disableCollectionModal() {
        this.tileCollections.forEach((collection) => {
            collection.classList.remove('product-stack__collection--active-modal')
        })
    }
}
